import {SET_USER_LOGGED_IN} from './type';

export const setUserLoggedIn = (loggedIn: boolean) => {
    // @ts-ignore
    return dispatch => {
        dispatch({
            type: SET_USER_LOGGED_IN,
            payload: loggedIn,
        });
    }
};
